import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { AUDIT_CATALOGS } from "./model/audit-copy.ts";

// The audit log under Settings (S4.08), admin-only: the door itself refuses a member or
// viewer (`audit:read`), and a 403 already renders the "no access" boundary, so this screen
// needs no role check of its own. No error copy of its own: the one read it makes has no
// refusal a person can act on beyond that boundary.
// Settings → Enterprise hides behind `enterprise-settings` (S43.05, D1370).
export const auditBrowserModule: BrowserModule = defineBrowserModule("audit")
  .withScreens({
    auditLog: {
      path: "/settings/audit-log",
      title: phrase(AUDIT_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "enterprise-settings",
      load: () => import("./ui/sections/audit-log-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "audit-log",
      group: "settings-enterprise",
      label: phrase(AUDIT_CATALOGS, "navAuditLog"),
      href: "/settings/audit-log",
      icon: "activity",
      order: 874,
      flag: "enterprise-settings",
    },
  ]);
